import React, { useState, useEffect, createContext } from 'react'
import { getSS, setSS } from '../helpers'

export const Context = createContext<any>(undefined)

interface Props {
  children: React.ReactNode;
}

export const MembershipFormProvider: React.FC<Props> = ({ children }) => {

  const [ preSelectedMembership, setPreSelectedMembership ] = useState(false)
  const [ currentStep, setCurrentStep ] = useState(1)

  useEffect(() => {
    const preSelectedMembership = getSS('preSelectedMembership')
    if (preSelectedMembership) {
      setPreSelectedMembership(preSelectedMembership)
    }
  }, [])

  const setPreSelected = (params: any) => {
    if (params) {
      setSS('preSelectedMembership', params)
      setPreSelectedMembership(params)
    } else {
      setSS('preSelectedMembership', false)
      setPreSelectedMembership(false)
    }
  }

  const showLoading = () => {
    (document as any).getElementById('loading').classList.add('show');
    (document as any).getElementById('body').classList.add('oh');
  }

  const hideLoading = () => {
    (document as any).getElementById('loading').classList.remove('show');
    (document as any).getElementById('body').classList.remove('oh');
  }

  let state = {
    setPreSelected,
    preSelectedMembership,
    setPreSelectedMembership,
    currentStep,
    setCurrentStep,
    showLoading,
    hideLoading
  }

  return <Context.Provider value={state}>{children}</Context.Provider>

}

export default Context